import React, { useState, useRef, useEffect } from 'react';
import {
  Card, Upload, Input, Button, Radio, Typography, Avatar, Progress, message, Slider, Select,
  Tooltip, Modal, Steps, Spin, Tour
} from 'antd';
import {
  UploadOutlined,
  PlayCircleOutlined,
  AudioOutlined,
  RobotOutlined,
  PauseCircleOutlined,
  SoundOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
  ClockCircleOutlined,
  DownloadOutlined,
  ExclamationCircleFilled,
  QuestionCircleOutlined
} from '@ant-design/icons';
import styles from './index.module.scss';
import type { UploadFile, UploadProps, RadioChangeEvent, InputRef, SelectProps } from 'antd';
import { useLocation } from 'react-router-dom';
import AudioPlayerCard from '../../components/AudioPlayCard';
import { generateVoice, getVoiceProcessing, getPublicOneTone } from '../../../api/voice'
import { AxiosResponse, AxiosError } from 'axios';
import type { Twin, TwinList } from '../../../types/twin/index'
import { getLatestTwin, createTwins, getTwinProcessStatus, getTwinList } from '../../../api/clone'
import type { VoiceItem } from '../../../types/voice'
import { getPublicVoiceList, getMyVoiceList } from '../../../api/voice';
import VideoPlayer from '../../components/VideoPlayer';
import { handleUrlDownload } from '../../../utils';
import { RcFile } from 'antd/es/upload/interface';
import AudioPlayer from '../../components/AudioPlayer';
import { ApiResponse } from '../../../types';
import type { GetRef, TourProps } from 'antd';
import { useTranslation } from 'react-i18next';

const VideoCreate = () => {
  const { TextArea } = Input;
  const { Title, Text } = Typography;
  const { Step } = Steps;
  const { confirm } = Modal;


  const [inputType, setInputType] = useState<string>('text');
  const [inputContent, setInputContent] = useState<string>('');
  const [aiGenerating, setAiGenerating] = useState<boolean>(false);
  const toneAudioRef = useRef<HTMLAudioElement>(null);
  const videoAudioRef = useRef<HTMLAudioElement>(null);
  const [speed, setSpeed] = useState<number>(1.0);
  const [switchAudio, setSwitchAudio] = useState<boolean>(false)
  // 1.声音试听;2.加载我的声音;3.加载公共声音;4.加载视频模板;
  const [loadings, setLoadings] = useState<boolean[]>([false, false, false, false, false])
  const [currentLang, setCurrentLang] = useState<string | undefined>(undefined)
  const [isVideoAudioPlaying, setIsVideoAudioPlaying] = useState<boolean>(false)
  const [videoAudio, setVideoAudio] = useState<string | Blob | undefined>(undefined)
  const [publicAudioPlaying, setPublicAudioPlaying] = useState<boolean>(false)


  const [defaultTemplate, setDefaultTemplate] = useState<Twin | null>(null)
  const [defaultVoice, setDefaultVoice] = useState<VoiceItem | null>(null)
  const [currentStatusId, setCurrentStatusId] = useState<number>(0)
  const [statusIdTitle, setStatusIdTitle] = useState<string>('音频处理排队中');
  const [isVoiceModal, setIsVoiceModal] = useState(false);
  const [publicVoiceList, setPublicVoiceList] = useState<VoiceItem[]>([])
  const [myVoiceList, setMyVoiceList] = useState<VoiceItem[]>([])
  const [currentVoiceId, setCurrentVoiceId] = useState<number | null>(null)
  const [currentVideoUrl, setCurrentVideoUrl] = useState<string | null>(null)
  const [isTemplateModal, setIsTemplateModal] = useState<boolean>(false)
  const [twinTemplateList, setTwinTemplateList] = useState<Twin[]>([])
  const [templateHasMore, setTemplateHasMore] = useState<boolean>(true)
  const [lastTemplateId, setLastTemplateId] = useState<number | null>(null)
  const [isGeneratingVideo, setIsGeneratingVideo] = useState<boolean>(false);
  const [audioFileName, setAudioFileName] = useState<string>('')
  const [audioSourceFile, setAudioSourceFile] = useState<Blob | null>(null)
  const [filePreviewUrl, setFilePreviewUrl] = useState<string | undefined>(undefined)
  const [audioDuration, setAudioDuration] = useState<number>(0);
  const [voiceTimer, setVoiceTimer] = useState<boolean>(false)
  const [videoTimer, setVideoTimer] = useState<boolean>(false)
  const [langHasError, setLangHasError] = useState(false)
  const [openTour, setOpenTour] = useState<boolean>(false)

  const timerRef = useRef<number | null>(null);


  const location = useLocation();
  const pageSize: number = 5;
  const { t } = useTranslation();

  const speedMarks = {
    0.5: '0.5',
    0.75: '0.75',
    1.0: t('clone.creation.speed.normal'),
    1.25: '1.25',
    1.5: '1.5',
    1.75: '1.75',
    2.0: '2.0'

  };

  const statusMap = [
    { title: '音频处理排队中', percent: 5 },
    { title: '音频正在处理中', percent: 30 },
    { title: '音频处理完成', percent: 50 },
    { title: '视频处理排队中', percent: 60 },
    { title: '视频正在处理中', percent: 80 },
    { title: '视频处理完成', percent: 100 }
  ]

  const ref1 = useRef<GetRef<typeof Radio.Group>>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  const ref3 = useRef<GetRef<typeof Button>>(null);
  const ref4 = useRef<GetRef<typeof Button>>(null);
  const ref5 = useRef<GetRef<typeof Button>>(null);
  const ref6 = useRef<GetRef<typeof Button>>(null);


  const tourSteps: TourProps['steps'] = [
    {
      title: '数字人创建提示',
      description: '选择输入内容类型，可以选择输入文本和上传音频文件',
      
      target: () => ref1.current!,
    },
    {
      title: '数字人创建提示',
      description: '如果使用文本内容选择对应的所属语言确保生成质量',
      target: () => ref2.current!,
    },
    {
      title: '数字人创建提示',
      description: '选择想要生成的音色模板',
      target: () => ref3.current!,
    },
    {
      title: '数字人创建提示',
      description: '如果需要试听文本内容可输入文本后点击使用',
      target: () => ref4.current!,
    },
    {
      title: '数字人创建提示',
      description: '选择对应的数字人模板',
      target: () => ref5.current!,
    },
    {
      title: '数字人创建提示',
      description: '点击生成视频，等待视频处理完成即可',
      target: () => ref6.current!,
    },
  ];

  useEffect(() => {
    const { state } = location


    if (state) {
      // from templates
      if (state.from === 'template') {
        setDefaultTemplate(state)
        getPublicOneTone({ id: 0 }).then((res: AxiosResponse) => {
          if (res.data.status === 200) {
            var tmp = { ...res.data.data }
            tmp.toneId = tmp.id
            setCurrentVoiceId(tmp.id)
            setDefaultVoice(tmp)
          }
        })
      }
      // from voices
      if (state.from === 'voice') {
        setDefaultVoice(state)
      }
    } else {
      // direct access
      getPublicOneTone({ id: 0 }).then((res: AxiosResponse) => {
        if (res.data.status === 200) {
          setCurrentVoiceId(res.data.data.id)
          setDefaultVoice(res.data.data)
        }
      })
    }

  }, [location.state])


  useEffect(() => {
    const onEnded = () => setPublicAudioPlaying(false);
    toneAudioRef.current?.addEventListener('ended', onEnded);
    return () => {
      toneAudioRef.current?.removeEventListener('ended', onEnded);
    };
  }, []);

  useEffect(() => {
    if (audioSourceFile) {
      const url = URL.createObjectURL(audioSourceFile);
      setFilePreviewUrl(url);

      // 组件卸载时释放 URL
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [audioSourceFile]);

  useEffect(() => {
    return () => {
      clearTimer();
    };
  }, []);

  useEffect(() => {
    handleOpenTour()
  }, [])

  const handleOpenTour = () => {
    const hasTourShown = localStorage.getItem('hasCreateVideoTour');
    if (hasTourShown !== 'true') {
      setOpenTour(true)
    }

  }

  const handleCloseTour = () => {
    localStorage.setItem('hasCreateVideoTour', 'true');
    setOpenTour(false)

  }

  const handleSpeedChange = (value: number) => {
    // console.log('speed: ', speed)
    setSpeed(value);
  };

  const handleInputTypeChange = (e: RadioChangeEvent) => {
    const val = e.target.value

    setInputType(val);
    if (val === 'audio') {
      setSwitchAudio(true)
    } else {
      setSwitchAudio(false)
      setVideoAudio(undefined)
      setAudioFileName('')
    }

    // setInputContent('');
  };

  const handleInputContentChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setInputContent(e.target.value);
  };


  const handleAudioUpload: UploadProps['customRequest'] = (options) => {
    const { file } = options

    if (!file) {
      message.error("请选择文件");
      return;
    }
    if ((file as RcFile).name) {
      setAudioFileName((file as RcFile).name)
      setAudioSourceFile((file as RcFile))
      setVideoAudio(file)
    }
  };

  const clearTimer = () => {
    if (timerRef.current) {
      window.clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleVideoGenerate = async () => {
    // generate audio before generate video
    if (inputType === 'text' && !inputContent) {
      message.warning("请输入文字内容")
      return
    }
    if (switchAudio && !audioSourceFile) {
      message.warning("请上传音频文件")
      return
    }

    if (!defaultTemplate || !defaultTemplate.id) {
      message.warning("请选择模板")
      return
    }
    if (inputType === 'text' && !defaultVoice) {
      message.warning("请选择声音")
      return
    }

    if (inputType === 'text' && !currentLang) {
			message.warning('请选择音频内容所属语言')
			setLangHasError(true)
			return 
		}

    setVideoTimer(false)
    

    if (switchAudio) {
      setCurrentStatusId(2)
      setStatusIdTitle('视频处理排队中')
    } else {

      setCurrentStatusId(0)
      setStatusIdTitle('音频处理排队中')
    }

    setCurrentVideoUrl(null)
    
    if (switchAudio) setCurrentStatusId(3);
    setIsGeneratingVideo(true); // global loading

    createTwins({
      'templateId': defaultTemplate.id,
      'voiceText': switchAudio ? '' : inputContent,
      'voiceType': switchAudio ? 1 : 0,
      'toneId': switchAudio ? 0 : (defaultVoice && defaultVoice.id),
      'language': switchAudio ? null : currentLang,
      'speed': switchAudio ? null : speed,
      'sourceFile': switchAudio ? audioSourceFile : null,
      'voiceDuration': audioDuration
    }).then((res: AxiosResponse<ApiResponse>) => {
      if (res.data.status === 200) {

        
        // console.log(res.data.data)
        const videoId = res.data.data.id
        const MAX_ATTEMPTS = 1800;
        let attempts = 0;

        const startTime = Date.now();
        const MAX_DURATION = 3600000;


        if (timerRef.current) {
          window.clearInterval(timerRef.current);
        }
        

        timerRef.current = window.setInterval(() => {
          setVideoTimer(true)

          // 检查是否超过最大尝试次数或最长时间
          if (attempts >= MAX_ATTEMPTS || Date.now() - startTime >= MAX_DURATION) {
            console.log('定时器已达到最大执行时间限制，自动停止');
            clearTimer();
            setIsGeneratingVideo(false); // 关闭加载状态
            return;
          }

          getTwinProcessStatus({ 'id': videoId }).then((_res: AxiosResponse) => {
            if (_res.data.status === 200) {
              
              
              const statusId = _res.data.data.statusId

              setCurrentStatusId(statusId)
              setStatusIdTitle(statusMap[statusId]?.title || '处理中')

              if (statusId === 5) {
                // after truely finished
                setCurrentLang(undefined)

                clearTimer();
                setIsGeneratingVideo(false);
                setCurrentVideoUrl(_res.data.data.videoUrl)
                // message.success('视频生成成功！');
                Modal.success({
                  centered: true,
                  title: '任务提示',
                  content: '视频生成成功，预览区可以点击播放'
                })
                // eject view video yes or no, yes/redirect video list, no/continue generate
              }
              // update the descript of step
              
            }
          }).catch((err) => {
            clearTimer()
            setIsGeneratingVideo(false);
          })

        }, 5000)
      } else if (res.data.status === 1009) {

        setIsGeneratingVideo(false);
        message.warning(res.data.message)
      } else if (res.data.status === 1010) {

        setIsGeneratingVideo(false);
        message.warning(res.data.message)
      }

    }).catch((err: AxiosError) => {
      setIsGeneratingVideo(false)
    })
  };

  const handleAIGenerate = () => {
    setAiGenerating(true);
    setTimeout(() => {
      setInputContent('AI生成的示例文案：欢迎使用我们的产品...');
      setAiGenerating(false);
      message.success('AI文案生成成功！');
    }, 2000);
  };

  const handleTonePlay = () => {
    // console.log(publicAudioPlaying)
    if (toneAudioRef.current) {
      if (publicAudioPlaying) {
        toneAudioRef.current.pause();
      } else {
        toneAudioRef.current.play();
      }
      setPublicAudioPlaying(!publicAudioPlaying);
      setTimeout(() => {
        // console.log(publicAudioPlaying)

      }, 3000)
    }
  };

  const handleVideoAudioPlay = () => {
    if (videoAudioRef.current) {
      videoAudioRef.current.oncanplay = () => {
        if (isVideoAudioPlaying) {
          if (videoAudioRef.current) {
            videoAudioRef.current.pause();
          } else {
            console.log("videoAudioRef.current is null")
          }

        } else {

          if (videoAudioRef.current) {
            videoAudioRef.current.play();
          } else {
            console.log("videoAudioRef.current is null")
          }
        }
        setIsVideoAudioPlaying(!isVideoAudioPlaying);
        // console.log(isVideoAudioPlaying)
      };
    }
  };

  const handleLangaugeChange = (value: string) => {
    // console.log(value)
    setCurrentLang(value)
    setLangHasError(false)
  }


  const enterLoading = (index: number, status: boolean = true) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = status;
      return newLoadings;
    });
  }

  const handleVoiceListen = () => {
    // console.log(inputContent, speed)
    if (loadings[1]) return

    if (inputType === 'text' && !inputContent) {
      message.warning("请输入文字内容")
      return
    } else if (inputType === 'text' && !defaultVoice) {
      message.warning("请选中一个使用声音")
      return
    }
    
    if (!currentLang) {
			message.warning('请选择音频内容所属语言')
			setLangHasError(true)
			return 
		}

    setVideoAudio(undefined)

    enterLoading(1)
    // console.log("speed--", speed, typeof(speed))

    generateVoice({
      'toneId': (defaultVoice && defaultVoice.id),
      'text': inputContent,
      'language': currentLang,
      'speed': speed.toString()
    }).then((res: AxiosResponse) => {
      
      if (res.data.status === 200) {

        const MAX_ATTEMPTS = 900;
        let attempts = 0;

        const startTime = Date.now();
        const MAX_DURATION = 1800000;

        if (timerRef.current) {
          window.clearInterval(timerRef.current);
        }
        
        setVoiceTimer(false)
        timerRef.current = window.setInterval(() => {
          // console.log('setInterval 被调用，当前 timerRef.current:', timerRef.current);
          setVoiceTimer(true)

          attempts++;

          // 检查是否超过最大尝试次数或最长时间
          if (attempts >= MAX_ATTEMPTS || Date.now() - startTime >= MAX_DURATION) {
            console.log('定时器已达到最大执行时间限制，自动停止');
            clearTimer();
            enterLoading(1, false)
            return;
          }

          getVoiceProcessing({ id: res.data.data['id'] }).then((_res: AxiosResponse) => {
            if (_res.data.status === 200) {
              if (_res.data.data.statusId === 1) {
                // 
              } else if (_res.data.data.statusId === 2) {
                clearTimer();
                // setVideoUrl(_res.data.data.videoUrl)
                setVideoAudio(_res.data.data.voiceUrl)
                // console.log(_res.data.data.voiceUrl)
                enterLoading(1, false)
                //handleVideoAudioPlay()
                setVoiceTimer(false)
                
              }
            } else {
              setVoiceTimer(false)
            }
          }).catch(() => {
            clearTimer()
            enterLoading(1, false)
            setVoiceTimer(false)
          })

        }, 5000)

      } else if (res.data.status === 1009) {
        message.error(res.data.message)
        clearTimer()
        enterLoading(1, false)

      }
    }).catch(() => {
      clearTimer()
      enterLoading(1, false)
    })
  }



  const handlePlayStateChange = (voiceId: number | null) => {
    setCurrentVoiceId(voiceId);
  }

  const handleUseButtonClick = (voice: VoiceItem) => {
    // setCurrentVoiceId(voice.id);
    setDefaultVoice(voice)
    setIsVoiceModal(false)
  }

  const handleSelectVoice = () => {
    setIsVoiceModal(true)
    enterLoading(2)
    enterLoading(3)

    getMyVoiceList({}).then((res: AxiosResponse) => {
      if (res.data.status === 200) {
        setMyVoiceList(res.data.data)
        enterLoading(2, false)
      }
    }).catch(() => {
      enterLoading(2, false)
      message.error("加载我的声音失败")
    })

    getPublicVoiceList({}).then((res: AxiosResponse) => {
      if (res.data.status === 200) {
        setPublicVoiceList(res.data.data)
        enterLoading(3, false)
      }
    }).catch(() => {
      enterLoading(3, false)
      message.error("加载公共声音失败")
    })
    // enterLoading(2, false)

  }

  const handleTemplateModal = () => {
    setIsTemplateModal(true)
    fetchTwinList()

  }

  const fetchTwinList = () => {
    if (loadings[4] || !templateHasMore) return;
    enterLoading(4)
    // console.log(currentPage)
    const lastId = lastTemplateId
    const params = {
      pageSize,
      ...(lastId ? { lastId } : {})
    };

    try {
      getTwinList(params).then((res: AxiosResponse<ApiResponse<TwinList>>) => {
        if (res.data.status === 200) {
          const newTwins: Twin[] = res.data.data.items

          setTwinTemplateList(prev => [...prev, ...newTwins]);
          setTemplateHasMore(res.data.data.hasMore);
          if (newTwins.length > 0) {
            setLastTemplateId(newTwins[newTwins.length - 1].id)
          }
          enterLoading(4, false)
        }
      }).catch((error: AxiosError) => {
        enterLoading(4, false)
      })
    } finally {
      //enterLoading(4, false)
    }
  }

  const handleLoadTemplate = () => {
    fetchTwinList()
  }


  const handleSelectTemplate = (twin: Twin) => {
    // console.log(twin)
    setDefaultTemplate(twin)
    setIsTemplateModal(false)
  }

  const handleCancelGenerateVideo = () => {

    confirm({
      title: '取消任务提示',
      icon: <ExclamationCircleFilled />,
      content: '取消后会在后台处理，处理状态在我的视频查看，但同时最多只能有一个在处理，确定取消吗？',
      onOk() {
        clearTimer()
        setIsGeneratingVideo(false);
      },
      onCancel() {
        // console.log('Cancel');
      },
    });

  }

  const handleDurationChange = (duration: number) => {
    // console.log('duration: ' , duration)
    setAudioDuration(duration)
  }

  const handleVoicePlayCancel = () => {
    clearTimer();
    enterLoading(1, false)
    setVoiceTimer(false)
  }


  return (
    <div className={styles.container}>
      <div className={styles.mainCard}>

        <div className={styles.content}>
          <Card className={styles.leftSection}>
            <div className={styles.inputSection}>
              <div className={styles.sectionHeader}>
                <Text strong className={styles.sectionTitle}>{t('clone.creation.content.title')}</Text>

              </div>
              <div className={styles.options}>
                <Radio.Group
                  onChange={handleInputTypeChange}
                  value={inputType}
                  className={styles.radioGroup}
                  ref={ref1}
                >
                  <Radio.Button value="text">{t('clone.creation.content.select1')}</Radio.Button>
                  <Radio.Button value="audio">{t('clone.creation.content.select2')}</Radio.Button>
                </Radio.Group>
                {/*
                 <Button 
                    type="default" 
                    icon={<RobotOutlined />}
                    onClick={handleAIGenerate}
                    loading={aiGenerating}
                    className={styles.aiButton}
                  >
                    AI生成文案
                  </Button>
                  */}
                <div className={styles.language} ref={ref2}>
                  <div className={styles.tip}>
                    {t('clone.creation.content.current_lang')}
                    {" "}
                    <Tooltip title={t('clone.creation.content.language_tip')}>
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>


                  <Select
                    value={currentLang}
                    placeholder={t('clone.creation.content.select_lang')}
                    status={langHasError? 'error': ''}
                    
                    className={styles.select}
                    onChange={handleLangaugeChange}
                    options={[
                      { value: 'all_zh', label: t('languages.zh') },
                      { value: 'en', label: t('languages.en') },
                      { value: 'all_ja', label: t('languages.ja') },
                      { value: 'all_ko', label: t('languages.ko') },
                      { value: 'all_yue', label: t('languages.yue') },
                      { value: 'zh', label: t('clone.creation.content.zh_en') },
                      { value: 'ja', label: t('clone.creation.content.ja_en') },
                      { value: 'ko', label: t('clone.creation.content.ko_en') },
                      { value: 'yue', label: t('clone.creation.content.yue_en') },
                      { value: 'auto', label: t('clone.creation.content.auto')}
                    ]}
                    disabled={switchAudio||loadings[1]}
                   
                  />
                </div>


              </div>
              {inputType === 'text' ? (
                <div className={styles.textInput}>
                  <TextArea
                    value={inputContent}
                    onChange={handleInputContentChange}
                    placeholder={t('clone.creation.content.placehoder')}
                    rows={19}
                    disabled={loadings[1]}
                    
                  />

                </div>
              ) : (
                <Upload
                  accept={".mp3, .wav"}
                  customRequest={handleAudioUpload}
                  showUploadList={false}
                  className={styles.upload}
                  disabled={inputType === 'text'}
                >
                  <Button icon={<UploadOutlined />}>
                    {t('clone.creation.voice.upload_audio')}
                  </Button>
                  <div className={styles.audioName}>{audioFileName ?? ''}</div>

                </Upload>
              )}
            </div>
          </Card>

          <Card className={styles.middleSection} >
            <div className={styles.previewSection}>


              <div className={styles.sectionHeader}>
                <Text strong className={styles.sectionTitle}>
                  {t('clone.creation.voice.title')}
                  <Tooltip title={t('clone.creation.voice.description')}>
                    <QuestionCircleOutlined className={styles.question} />
                  </Tooltip>
                </Text>
                <Button size="small" color="primary" variant="filled" onClick={handleSelectVoice} className={styles.button} disabled={switchAudio || loadings[1]} ref={ref3}>{t('clone.creation.voice.choose')}</Button>
              </div>
              <div className={styles.voiceWindow}>

                <Card className={`${styles.voiceCard} ${(switchAudio || loadings[1]) ? styles.disabled : ''}`} hoverable>
                  <audio ref={toneAudioRef} src={defaultVoice ? defaultVoice.audioUrl : ''} />
                  <div className={styles.cardContent}>
                    <div className={styles.left}>
                      {publicAudioPlaying ? (
                        <PauseCircleOutlined className={styles.play} onClick={handleTonePlay} />
                      ) : (
                        <PlayCircleOutlined className={styles.play} onClick={handleTonePlay} />
                      )}


                      <div className={styles.title}>{defaultVoice ? defaultVoice.name : ''}</div>
                    </div>

                  </div>
                </Card>


                <div className={styles.sectionHeader}>
                  <Text strong className={styles.sectionTitle}>
                    {t('clone.creation.speed.title')} 
                    <Tooltip title={t('clone.creation.speed.description')} >
                      <QuestionCircleOutlined className={styles.question} />
                    </Tooltip>
                  </Text>
                </div>

                <Card className={`${styles.speedSliderContainer} ${(switchAudio || loadings[1]) ? styles.disabled : ''}`} hoverable>
                  <Slider
                    min={0.5}
                    max={2.0}
                    step={0.25}
                    marks={speedMarks}
                    included={false}
                    defaultValue={1.0}
                    onChange={handleSpeedChange}
                    value={speed}
                    disabled={switchAudio || loadings[1]}
                  />
                  <div className={styles.currentSpeed}>{t('clone.creation.speed.current')} : {speed === 1.0 ? t('clone.creation.speed.normal') : speed + t('clone.creation.speed.x')}</div>
                </Card>


              </div>

              <div className={styles.sectionHeader}>
                <Text strong className={styles.sectionTitle}>
                  {t('clone.creation.listen.title')}
                  <Tooltip title={t('clone.creation.listen.description')} >
                    <QuestionCircleOutlined className={styles.question} />
                  </Tooltip>
                </Text>
                <div className={styles.voiceTryPlay}>
                  <Button
                    size="small"
                    color="primary"
                    variant="filled"
                    loading={loadings[1]}
                    onClick={handleVoiceListen}
                    disabled={switchAudio}
                    ref={ref4}
                  >
                    {t('clone.creation.listen.play')}
                  </Button>
                  {voiceTimer && loadings[1] && <Button size="small" onClick={handleVoicePlayCancel}>{t('clone.creation.listen.cancel')}</Button>}
                </div>
              </div>

              <Spin spinning={loadings[1]}>
                <AudioPlayer src={videoAudio} onDurationChange={handleDurationChange} />
              </Spin>

            </div>
          </Card>


          <Card className={styles.rightSection}>
            <div className={styles.previewSection}>
              <div className={styles.sectionHeader}>
                <Text strong className={styles.sectionTitle}>{t('clone.creation.preview.title')}</Text>
                <div className={styles.videoTools}>
                  <Tooltip title={t('clone.creation.preview.download_tip')}>
                    <Button icon={<DownloadOutlined />} disabled={currentVideoUrl === null} onClick={() => handleUrlDownload(currentVideoUrl)} />
                  </Tooltip>
                  <Button variant="solid" color="primary" className={styles.generateButton} onClick={handleVideoGenerate} disabled={loadings[1]} ref={ref6}>{t('clone.creation.preview.generate')}</Button>

                </div>
              </div>
              <div className={styles.previewWindow}>
                {
                  currentVideoUrl ? (
                    <VideoPlayer src={currentVideoUrl} width={300} maxHeight={300} />

                  ) : (
                    <div className={styles.tip}>
                      {t('clone.creation.preview.tip')}
                    </div>
                  )
                }


              </div>


              <div className={styles.sectionHeader}>
                <Text strong className={styles.sectionTitle}>
                  {t('clone.creation.template.title')}
                  <Tooltip title={t('clone.creation.template.description')} >
                    <QuestionCircleOutlined className={styles.question} />
                  </Tooltip>
                </Text>
                <Button size="small" color="primary" variant="filled" className={styles.button} onClick={handleTemplateModal} ref={ref5}>{t('clone.creation.template.choose')}</Button>
              </div>

              <div className={styles.templatePreview}>
                {
                  (defaultTemplate && defaultTemplate.videoUrl) ? <VideoPlayer src={defaultTemplate.videoUrl} width={120} maxHeight={120} /> :
                    <div className={styles.tip}>{t('clone.creation.template.tip')}</div>
                }

              </div>
            </div>
          </Card>


        </div>
      </div>


      <Modal
        title={null}
        open={isGeneratingVideo}
        closable={false}
        maskClosable={false}
        centered
        className={styles.processingModal}
        width={500}
        footer={null} // 移除默认的footer，使用自定义footer
      >
        <div className={styles.processingContent}>
          <Title level={4} className={styles.processingTitle}>
            处理进度
          </Title>

          <Progress
            percent={statusMap[currentStatusId]?.percent || 0}
            status={currentStatusId === 4 ? "success" : "active"}
            strokeWidth={8}
          />

          <Text className={styles.statusText}>
            {statusIdTitle}
          </Text>

          <Steps
            direction="vertical"
            current={currentStatusId}
            className={styles.processingSteps}
          >
            <Step
              title="音频处理排队中"
              icon={currentStatusId > 0 ? <CheckCircleOutlined /> : currentStatusId === 0 ? <LoadingOutlined /> : <ClockCircleOutlined />}
            />
            <Step
              title="音频正在处理中"
              icon={currentStatusId > 1 ? <CheckCircleOutlined /> : currentStatusId === 1 ? <LoadingOutlined /> : <ClockCircleOutlined />}
            />
            <Step
              title="音频处理已完成"
              icon={currentStatusId > 2 ? <CheckCircleOutlined /> : currentStatusId === 2 ? <LoadingOutlined /> : <ClockCircleOutlined />}
            />
            <Step
              title="视频处理排队中"
              icon={currentStatusId > 3 ? <CheckCircleOutlined /> : currentStatusId === 3 ? <LoadingOutlined /> : <ClockCircleOutlined />}
            />
            <Step
              title="视频正在处理"
              icon={currentStatusId > 4 ? <CheckCircleOutlined /> : currentStatusId === 4 ? <LoadingOutlined /> : <ClockCircleOutlined />}
            />
            <Step
              title="视频处理完成"
              icon={currentStatusId === 5 ? <CheckCircleOutlined /> : <ClockCircleOutlined />}
            />
          </Steps>

          <div className={styles.buttonContainer}>

            <Button
              className={styles.cancelButton}
              danger
              onClick={handleCancelGenerateVideo}
              disabled={!videoTimer}
            >
              取消处理
            </Button>
          </div>
        </div>
      </Modal>


      <Modal
        open={isVoiceModal}
        onCancel={() => setIsVoiceModal(false)}
        footer={null}
        width={1000}
      >
        <>
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <Text strong className={styles.sectionTitle}>{t('voice.title1')}</Text>
            </div>
            <Spin spinning={loadings[2]}>

              <div className={styles.voiceGrid}>
                {myVoiceList && myVoiceList.length > 0 ? (
                  <>
                    {myVoiceList.map((voice: VoiceItem) => (
                      <AudioPlayerCard
                        key={voice.id}
                        voice={voice}
                        currentPlayingId={currentVoiceId}
                        onPlayStateChange={handlePlayStateChange}
                        onUseButtonClick={handleUseButtonClick}
                      />
                    ))}
                  </>
                ) : (
                  <Card className={styles.emptyState}>
                    <p>暂无</p>
                  </Card>
                )}
              </div>

            </Spin>
          </div>

          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <Text strong className={styles.sectionTitle}>{t('voice.title2')}</Text>
            </div>
            <Spin spinning={loadings[3]}>
              <div>
                <div className={styles.voiceGrid}>
                  {
                    publicVoiceList.map((voice: VoiceItem) => (
                      <AudioPlayerCard
                        key={voice.id}
                        voice={voice}
                        currentPlayingId={currentVoiceId}
                        onPlayStateChange={handlePlayStateChange}
                        onUseButtonClick={handleUseButtonClick}
                      />
                    ))
                  }
                </div>
              </div>
            </Spin>
          </div>

        </>
      </Modal>

      <Modal
        open={isTemplateModal}
        onCancel={() => setIsTemplateModal(false)}
        width={902}
        footer={null}
      >
        <div>
          <div className={styles.sectionHeader}>
            <Text strong className={styles.sectionTitle}>{t('clone.creation.template.title2')}</Text>
          </div>
          <Spin spinning={loadings[4]}>
            <div className={styles.templateModal}>
              {
                twinTemplateList.map((twin: Twin, index: number) => (
                  <div key={index}>
                    {twin.processStatus === 2 ?
                      <div className={styles.twinCard}>
                        <VideoPlayer src={twin.videoUrl} width={200} maxHeight={200} />
                        <Button color="primary" variant="filled" className={styles.select} onClick={() => handleSelectTemplate(twin)}>{t('apply')}</Button>
                      </div> :
                      <div className={styles.loadCard}>
                        {twin.processStatus === 1 ? '视频正在处理中' : '视频处理排队中'}
                      </div>
                    }
                  </div>
                ))
              }
              {templateHasMore && twinTemplateList.length !== 0 &&
                <div className={styles.loadCard} onClick={handleLoadTemplate}>
                  {t('load_more')}

                </div>
              }
            </div>
          </Spin>
        </div>
      </Modal>
      
      <Tour open={openTour} onClose={handleCloseTour} steps={tourSteps} />


    </div>
  );
};

export default VideoCreate;